import Splitpanes from './splitpanes'
import Pane from './pane'

export { Splitpanes, Pane }
